<template>
  <div class="rating__masked-bg" role="dialog">
    <div
      class="rating__modal"
      :style="
        `background-image: url(${backgroundUrl}), linear-gradient(${$getGradient()}); background-size: cover;`
      "
    >
      <XIcon class="rating__close-btn-icon" color="#fff" @click="handleClose" />
      <div class="rating__content-details">
        <p class="rating__content-type">{{ modelTypeLabel }}</p>
        <h3 class="rating__content-name">
          {{ modelName }}
        </h3>
        <div v-if="instructor" class="rating__content-instructor">
          <img
            class="rating__content-instructor-img"
            :src="$getInstructorImg(instructor.profile_img_url)"
            :alt="`INE Instructor ${instructor.name}`"
          />
          <p class="rating__content-instructor-name">{{ instructor.name }}</p>
        </div>
      </div>

      <div class="rating__form-tile">
        <FeedbackForm
          :rating="{ ...rating, model_id: modelId, model_type: modelType }"
          :instructor="instructor"
          @close="handleClose"
          @save="handleSave"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackForm from '@/components/forms/FeedbackForm.vue'
import { modalOpenHooks } from '@/helpers/mixins'
import { XIcon } from 'vue-feather-icons'
import CONSTANTS from '@/constants'

export default {
  name: 'RatingModal',
  components: {
    FeedbackForm,
    XIcon,
  },
  mixins: [modalOpenHooks],
  props: {
    modelId: {
      type: String,
      required: true,
    },
    modelType: {
      type: String,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
    instructor: {
      type: Object,
      required: false,
    },
    rating: {
      type: Object,
      required: false,
    },
  },
  data: () => {
    return {
      needsRefresh: false,
    }
  },
  computed: {
    modelTypeLabel() {
      const { CONTENT_TYPES } = CONSTANTS

      if (this.modelType === CONTENT_TYPES.LEARNING_PATH) {
        return 'learning path'
      } else {
        return this.modelType
      }
    },
    backgroundUrl() {
      const { CONTENT_TYPES } = CONSTANTS
      switch (this.modelType) {
        case CONTENT_TYPES.COURSE:
          return this.$getCourseBackground(this.modelId, 'large')
        default:
          return null
      }
    },
  },
  methods: {
    handleSave() {
      this.needsRefresh = true
    },
    handleClose() {
      if (this.needsRefresh) {
        this.$emit('close-and-refresh')
      } else {
        this.$emit('close')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.rating {
  &__masked-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    background: rgba(21, 21, 21, 0.8);
    z-index: 9999;

    @include mobile {
      justify-content: center;
    }
  }

  &__modal {
    position: relative;
    width: 100%;
    height: 85%;
    border-radius: 35px 35px 0 0;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    > div {
      width: 100%;
    }
    @include mobile {
      border-radius: 35px;
      flex-direction: row;
      height: 480px;
      width: 855px;
      > div {
        width: 50%;
      }
    }
  }
  &__close-btn-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;

    @include mobile {
      top: 30px;
      right: 30px;
    }
  }
  &__form {
    &-tile {
      padding: 20px;
      background: var(--glass-mid-gray), #1e1e1e;
      flex-grow: 1;

      @include mobile {
        border-radius: 35px;
        padding: 30px;
        padding-top: 64px;
      }
    }
  }
  &__content {
    &-details {
      display: flex;
      flex-direction: column;

      padding: 20px;
      // add close icon height
      padding-top: 44px;

      @include mobile {
        padding: 30px;
      }
    }
    &-type {
      margin: 0 0 5px;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      font-size: 1rem;
      font-style: normal;
      font-weight: 450;
      line-height: 1.5rem;
      text-transform: uppercase;

      @include mobile {
        margin-top: 80px;

        font-weight: 500;
        font-size: 1.125rem;
      }
    }
    &-name {
      margin: 0;

      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      font-style: normal;
      font-weight: 700;
      font-size: 1.5rem;
      line-height: 2rem;

      @include mobile {
        font-size: 2rem;
        line-height: 2.375rem;
      }
    }
    &-instructor {
      display: flex;
      margin-top: 5px;
      gap: 10px;
      align-items: center;

      @include mobile {
        margin-top: 20px;
      }
      &-img {
        border-radius: 100%;
        width: 44px;
        height: 44px;
      }
      &-name {
        margin: 0;

        color: var(--white);
        font-feature-settings: 'clig' off, 'liga' off;

        font-family: var(--font-medium);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 23px; /* 143.75% */
      }
    }
  }
}
</style>
